import { attach, createEffect, createStore, sample } from 'effector'

import { $fanId, updateFanTimezone } from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { fanInfoService } from '@/modules/chatting/service/fan-info.ts'
import { apiClientChatting } from '@/utils/axios.ts'
import { handleError } from '@/utils/error'

export const updateTimeZoneFx = attach({
  name: 'update fan timezone',
  source: {
    creatorId: $creatorId,
    fanId: $fanId,
  },
  mapParams: (timeZone: string, { fanId, creatorId }) => ({
    timeZone,
    creatorId: creatorId!,
    fanId: fanId!,
  }),
  effect: createEffect(
    async ({
      creatorId,
      fanId,
      timeZone,
    }: {
      creatorId: number
      fanId: number
      timeZone: string
    }) => {
      await fanInfoService.updateLocalTime(creatorId, fanId, timeZone)

      return { fanId, timeZone }
    },
  ),
})

updateTimeZoneFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while updating timezone')
})

export const syncTimeZoneWithCountryFx = attach({
  name: 'sync timezone with country',
  source: {
    creatorId: $creatorId,
    fanId: $fanId,
  },
  mapParams: (_: unknown, { fanId, creatorId }) => ({
    creatorId: creatorId!,
    fanId: fanId!,
  }),
  effect: createEffect(
    async ({ creatorId, fanId }: { creatorId: number; fanId: number }) => {
      const { data: timeZone } = await apiClientChatting.put<string>(
        `of-chat/${creatorId}/user/${fanId}/time-shift`,
      )

      return { fanId, timeZone }
    },
  ),
})

syncTimeZoneWithCountryFx.failData.watch((error) => {
  handleError(error, 'Something went wrong while syncing timezone with country')
})

export const $isTimezoneSync = createStore<boolean>(false, {
  name: 'flag is timezone sync with country',
}).on(syncTimeZoneWithCountryFx.doneData, () => true)

sample({
  clock: [updateTimeZoneFx.doneData, syncTimeZoneWithCountryFx.doneData],
  target: updateFanTimezone,
})
